import React from "react";
import TransportLayout from "./transportLayout";
import MorningServiceImg from "assets/morning/service.png";
import Seo from "components/Seo";

const MorningService = () => {
    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="모닝서비스" />
            <TransportLayout>
                <div className="flex-1 bg-[#f4f4f4] flex flex-col items-center pb-16 pt-5 responsive1200:pt-[0px] responsive1200:px-[4%]">
                    <p className="py-[35px] text-[#333] text-[28px] font-[500] responsive1200:py-[30px] responsive1200:text-[24px]">
                        모닝서비스
                    </p>
                    <div className="bg-white w-full max-w-[1200px] py-[80px] px-[95px] flex flex-col responsive1200:px-[4%] responsive1200:py-[10%]">
                        <img className="animate-fade-in" src={MorningServiceImg} alt="MorningServiceImg" />

                        <div className="flex w-full gap-12 justify-center mt-10 responsive1200:grid responsive1200:grid-cols-1 responsive1200:gap-0 responsive1200:mt-0">
                            <div className="flex items-center flex-col w-full">
                                <div className="bg-base text-white flex w-full max-w-[300px] translate-y-6 h-[46px] rounded-full items-center justify-center gap-1.5">
                                    <p className="text-[17px] font-[500] pt-0.5">모닝택배</p>
                                    <p className="text-[15px]">(서울·경기·대구·부산지역)</p>
                                </div>
                                <div className="w-[525px] h-[220px] bg-back border border-[#ddd] flex flex-col items-center justify-center responsive1200:p-[38px_15px_25px] responsive1200:w-full responsive1200:h-auto">
                                    <p className="text-[#666] text-center leading-7 break-keep responsive1200:text-[14px]">
                                        비용은 저렴하지만 배송시간이 긴 일반택배와 배송시간은 빠르나{" "}
                                        <br className="responsive1200:hidden" />
                                        비용이 비싼 퀵서비스 대체 상품으로써 오전 9시 출근과 동시에
                                    </p>
                                    <p className="text-base font-[500] text-center leading-7 break-keep responsive1200:text-[14px]">
                                        서울지역, 경기지역, 대구지역간 빠르고 정확한 배송이 가능한 <br className="responsive1200:hidden" />
                                        저렴한 주력 배송서비스
                                    </p>
                                </div>
                            </div>
                            <div className="flex items-center flex-col w-full">
                                <div className="bg-air text-white flex w-full max-w-[300px] translate-y-6 h-[46px] rounded-full items-center justify-center gap-1.5">
                                    <p className="text-[17px] font-[500] pt-0.5">모닝행낭</p>
                                    <p className="text-[15px]">(원단·의류·서류)</p>
                                </div>
                                <div className="w-[525px] h-[220px] bg-back border border-[#ddd] flex flex-col items-center justify-center responsive1200:p-[38px_15px_25px] responsive1200:w-full responsive1200:h-auto">
                                    <p className="text-[#666] text-center leading-7 break-keep responsive1200:text-[14px]">
                                        서울·경기지역과 대구·부산지역간
                                        <br className="responsive1200:hidden" />
                                        다량의 소규모 화물이 오고가는
                                    </p>
                                    <p className="text-air font-[500] text-center leading-7 break-keep responsive1200:text-[14px]">
                                        고객들을 위한 빠르고 정확한 맞춤 배송서비스
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="mt-3 flex w-full gap-12 justify-center responsive1200:grid responsive1200:grid-cols-1 responsive1200:gap-0">
                            <div className="flex items-center flex-col w-full">
                                <div className="bg-express text-white flex w-full max-w-[395px] translate-y-6 min-h-[46px] px-[20px] rounded-full items-center justify-center">
                                    <p className="text-[17px] font-[500] pt-0.5">
                                        모닝화물
                                        <span className="text-[15px] ml-[6px] font-[400]">(인천공항·인천항 전국 Door to Door 서비스)</span>
                                    </p>
                                </div>
                                <div className="w-[525px] h-[220px] bg-back border border-[#ddd] flex flex-col items-center justify-center  responsive1200:p-[38px_15px_25px] responsive1200:w-full responsive1200:h-auto">
                                    <p className="text-[#666] text-center leading-7 break-keep responsive1200:text-[14px]">
                                        서울·경기·대구지역과 인천 공항 및 인천항간
                                    </p>
                                    <p className="text-express font-[500] text-center leading-7 break-keep responsive1200:text-[14px]">
                                        중요한 해외수출물량과 대규모화물에 대한 <br className="responsive1200:hidden" /> 안전하고 정확한
                                        특급 배송서비스
                                    </p>
                                </div>
                            </div>
                            <div className="flex items-center flex-col w-full">
                                <div className="bg-quick text-white flex w-full max-w-[300px] translate-y-6 min-h-[46px] px-[20px] rounded-full items-center justify-center">
                                    <p className="text-[17px] font-[500] pt-0.5">
                                        모닝특송
                                        <span className="text-[15px] ml-[6px] font-[400]">(해외수입화물 배송서비스)</span>
                                    </p>
                                </div>
                                <div className=" w-[525px] h-[220px] bg-back border border-[#ddd] flex flex-col items-center justify-center responsive1200:p-[38px_15px_25px] responsive1200:w-full responsive1200:h-auto">
                                    <p className="text-[#666] text-center leading-7 break-keep responsive1200:text-[14px]">
                                        해외에서 수입되어 고객에게
                                    </p>
                                    <p className="text-quick font-[500] text-center leading-7 break-keep responsive1200:text-[14px]">
                                        긴급하게 배송되어야하는 인바운드 화물에 대한 <br className="responsive1200:hidden" />
                                        당일 일괄 배송서비스
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </TransportLayout>
        </React.Fragment>
    );
};

export default MorningService;
